import { Button } from "@/components/ui/button";
import { Loader2, Send } from 'lucide-react';
import { useNotify, useRecordContext, useUpdate } from 'ra-core';
import { useState } from 'react';
import type { RFQ } from '../types';

export const SendRFQButton = () => {
    const record = useRecordContext<RFQ>();
    const notify = useNotify();
    const [update, { isPending }] = useUpdate();
    const [loading, setLoading] = useState(false);

    if (!record || record.status !== 'draft') return null;

    const handleSend = () => {
        setLoading(true);
        update(
            'rfqs',
            { id: record.id, data: { status: 'sent', sent_at: new Date().toISOString() }, previousData: record },
            {
                onSuccess: () => {
                    notify('RFQ sent to vendors successfully', { type: 'success' });
                    setLoading(false);
                },
                onError: (error: any) => {
                    notify(`Error sending RFQ: ${error.message}`, { type: 'error' });
                    setLoading(false);
                }
            }
        );
    };

    return (
        <Button 
            onClick={handleSend} 
            disabled={loading || isPending}
            variant="default"
            className="bg-blue-600 hover:bg-blue-700 text-white gap-2 h-9 px-4 rounded-md shadow-sm transition-all"
        >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
            Send to Vendors
        </Button>
    );
};
